var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrecipAnnualAccumulated({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u62A5\\u544A",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "A4---6",
    transform: "translate(-28, -579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(28, 579)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.692871094,1.52539062 L1.58125,1.52539062 L1.58125,3.37089844 L0.675683594,3.37089844 L0.675683594,4.33769531 L1.58125,4.33769531 L1.58125,6.65908203 L0.675683594,6.65908203 L0.675683594,7.62587891 L1.58125,7.62587891 L1.58125,9.39082031 L0.742285156,9.39082031 L0.742285156,10.3576172 L2.54804687,10.3576172 L2.54804687,0.55859375 L0.692871094,0.55859375 L0.692871094,1.52539062 Z M8.79570312,2.38476563 C8.74414063,1.94863281 8.53681641,1.54580078 8.20166016,1.23320313 C7.81923828,0.878710937 7.31435547,0.683203125 6.77832031,0.683203125 C6.24228516,0.683203125 5.73740234,0.878710937 5.35498047,1.23320313 C5.01875,1.54580078 4.8125,1.94863281 4.7609375,2.38476563 C3.89619141,2.53193359 3.23876953,3.25058594 3.23876953,4.11210938 C3.23876953,5.07998047 4.06914063,5.86630859 5.08964844,5.86630859 L8.46699219,5.86630859 C9.4875,5.86630859 10.3178711,5.07890625 10.3178711,4.11210938 C10.3178711,3.25058594 9.66044922,2.53300781 8.79570312,2.38476563 Z M4.69970703,6.73964844 C4.43222656,6.73964844 4.21630859,6.95556641 4.21630859,7.22304688 L4.21630859,9.44990234 C4.21630859,9.71738281 4.43222656,9.93330078 4.69970703,9.93330078 C4.9671875,9.93330078 5.18310547,9.71738281 5.18310547,9.44990234 L5.18310547,7.22304688 C5.18310547,6.95556641 4.96611328,6.73964844 4.69970703,6.73964844 Z M6.94482422,6.73964844 C6.67734375,6.73964844 6.46142578,6.95556641 6.46142578,7.22304687 L6.46142578,8.15224609 C6.46142578,8.41972656 6.67734375,8.63564453 6.94482422,8.63564453 C7.21230469,8.63564453 7.42822266,8.41972656 7.42822266,8.15224609 L7.42822266,7.22304687 C7.42822266,6.95556641 7.21230469,6.73964844 6.94482422,6.73964844 Z M8.96542969,6.73964844 C8.69794922,6.73964844 8.48203125,6.95556641 8.48203125,7.22304687 L8.48203125,9.79902344 C8.48203125,10.0665039 8.69794922,10.2824219 8.96542969,10.2824219 C9.23291016,10.2824219 9.44882813,10.0665039 9.44882813,9.79902344 L9.44882813,7.22304687 C9.44882813,6.95556641 9.23291016,6.73964844 8.96542969,6.73964844 Z",
    id: "\\u5F62\\u72B6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecipAnnualAccumulated);
export default __webpack_public_path__ + "static/media/precip_annual_accumulated.c3d18800bd90074f390d16d1867516b3.svg";
export { ForwardRef as ReactComponent };